import { handleRequest } from "../utilities/requestHandler";

export const getAllMachineModels = () =>
    handleRequest("get", "/machines/models");

export const getAllOptions = () =>
    handleRequest("get", "/options/");

export const sendPasswordResetLink = (req_body) =>
    handleRequest("post","/users/passwordresetlink", req_body);

export const deleteUsers = (req_body) =>
    handleRequest("post","/users/delete",req_body);

export const insertOptions = (req_body) =>
    handleRequest("post","/options/insert",req_body);

export const getEndpointData = (endpoint) =>
    handleRequest("get", endpoint);

export const getVersionInfo = () => handleRequest("get", "/system/version");
export const getPipelineMonitorSummary = () => handleRequest("get", "/system/pipeline-monitor/summary");
export const getStepSyncStats = () => handleRequest("get", "/system/pipeline-monitor/step-sync/stats");
export const getStepSyncRequests = (params = {}) =>
	handleRequest("get", "/system/pipeline-monitor/step-sync/requests", params);
export const getStepSyncRequestEvents = (id) =>
	handleRequest("get", `/system/pipeline-monitor/step-sync/${id}/events`);
/**
 * Reset one STEP sync request to 'pending' so the pipeline re-runs it.
 *
 * @param {number|string} id Request id.
 * @param {"simple"|"hard"} [mode="simple"] "hard" also rebuilds the model even when the
 *   source CAD file is unchanged. Either way the server re-checks whether the published
 *   model is still on disk, which a reset previously did not do.
 * @returns {Promise<object>} Envelope whose data holds the updated request row.
 */
export const resetStepSyncRequest = (id, mode = "simple") =>
	handleRequest("post", `/system/pipeline-monitor/step-sync/${id}/reset`, { mode });
export const holdStepSyncRequest = (id) =>
	handleRequest("post", `/system/pipeline-monitor/step-sync/${id}/hold`);
export const cancelStepSyncRequest = (id) =>
	handleRequest("post", `/system/pipeline-monitor/step-sync/${id}/cancel`);
export const deleteStepSyncRequest = (id) =>
	handleRequest("delete", `/system/pipeline-monitor/step-sync/${id}`);
export const clearStepSyncRequests = () =>
	handleRequest("post", "/system/pipeline-monitor/step-sync/clear");
export const getDocumentSyncStats = () => handleRequest("get", "/system/pipeline-monitor/doc-sync/stats");
export const getDocumentSyncRequests = (params = {}) =>
	handleRequest("get", "/system/pipeline-monitor/doc-sync/requests", params);
export const clearDocumentSyncRequests = () =>
	handleRequest("post", "/system/pipeline-monitor/doc-sync/clear");

// Every row matching the filters, unpaged, with only the columns the .xlsx
// prints. Replaces the old select-all loop that paged this same list 200 rows at
// a time and stopped at 4000.
export const exportStepSyncRequests = (params = {}) =>
	handleRequest("get", "/system/pipeline-monitor/step-sync/requests/export", params);

/**
 * Preview the next STEP file sync report without sending it.
 *
 * Dry run on the server: recipients are resolved and the window computed, but
 * no email goes out and no row is marked. The returned diagnostics carry a
 * plain-English `reason` explaining why a report would or would not be sent.
 *
 * @returns {Promise<object>} Envelope whose data is the report diagnostics.
 */
export const previewStepSyncReport = () =>
	handleRequest("post", "/machines/step-sync/report/preview");

/**
 * Send the STEP file sync report immediately, bypassing the nightly schedule.
 *
 * Does not consume the day, so the scheduled 05:00 ET run still goes out.
 * Rows already reported are never re-sent, so pressing this twice is safe.
 *
 * @returns {Promise<object>} Envelope whose data is the report diagnostics.
 */
export const sendStepSyncReportNow = () =>
	handleRequest("post", "/machines/step-sync/report/send");


// ---------------- Scheduler API services ---------------- 
export const getSchedulers = () => handleRequest("get", "/schedular");

// NEW: Get schedule execution history
export const getScheduleHistory = (limit = 10) => 
  handleRequest("get", `/schedular/history?limit=${limit}`);

export const startScheduler = (job) => handleRequest("post", "/schedular/start", job);

export const stopScheduler = (name) => handleRequest("post", `/schedular/stop/${name}`);

export const createScheduler = (record) => handleRequest("post", "/schedular/create", record);

export const updateScheduler = (id, data) => handleRequest("put", `/schedular/${id}`, data);

// NEW: Get scheduler health status
export const getSchedulerHealth = () => handleRequest("get", "/schedular/health");
